// extracted by mini-css-extract-plugin
export default {"wrapper":"form_wrapper__oGNyu","message":"form_message__fSVAE","slide":"form_slide__Nt3Nl"};